import { Part } from '@/Engine/Part';
import { mapAccessoryToHoles } from '@/Constants/accessoryHoles';
import { $ } from '@/Engine/state';
import { mapTypeToHoles } from '@/Constants/holes';

export function getHolesForSelectedModel(obj: Part) {
    let holes;
    if (obj.key === 'accessory') {
        if (!mapAccessoryToHoles[obj.model.name]) {
            console.warn('Массив отверстий не найден для', obj.model.name);
            return [ 0 ];
        }
        holes = mapAccessoryToHoles[obj.model.name][$.toolChest.blenderName];
    } else {
        if (!mapTypeToHoles[obj.model.name]) {
            console.warn('Массив отверстий не найден для', obj.model.name);
            return [ 0 ];
        }
        holes = mapTypeToHoles[obj.model.name][$.toolChest.blenderName];
    }
    return holes ?? [ 0 ];
}

export function getIndexInHoles(holes: number[], pointer: number) {
    pointer = [ ...holes ].sort((a,b) => Math.abs(a - pointer) - Math.abs(b - pointer))[0];
    const index = holes.indexOf(pointer);
    if (index === -1) {
        console.error('Индекс ближайшего отверстия в массиве не найден для комплектующего', $.selectedModel?.name);
        return -1;
    }
    return index;
}